module.exports = __webpack_public_path__ + "img/Deaminasevariants_M.b2f9ab14.svg";